import styled from 'styled-components';

export const TileContentContainer = styled.div`
  width: 100%;
  padding: 30px 40px 0 20px;
  margin: 40px auto auto auto;

  /* Rechart tick values */
  .recharts-cartesian-axis-tick-value {
    font-size: 12px;
    line-height: 17px;
    fill: ${({ theme }) => theme.colors.palette[5]};
  }
  .recharts-tooltip-cursor {
      fill: #F3F4F5;
    }
`;
